export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const FILE_SIZE_ERROR_MESSAGE = `File size exceeds ${MAX_FILE_SIZE_MB} MB. Please upload a smaller file.`;
